import { FeatureFlag } from '../FeatureFlag';

export const enableLab2GroupByStatusToggle = new FeatureFlag({
    key: 'enable-lab-2-group-by-status-toggle',
    createdOn: '2026-10-13',
    defaultValue: false,
});
